module.exports = __webpack_public_path__ + "img/HyperBio_icon.6539ab31.png";